import React, { Component } from "react";
import { Form } from "antd";
import {
  getPrimaryAccount,
  getAccountData
} from "../../../../../utils/sessionUtil";
import Preloader from "../../../../Preloader/Preloader";
import {
  DrawerHeader,
  DescriptionPara,
  FaqLinkPara,
  HR,
  Ahref,
  FundFromPara,
  FundFrom,
  RowWrapper,
  InputHeader,
  SubmitButton,
  InputRowWrapper,
  TextAreaColWrapper
} from "./style";
/*************************/
import { submitNeedAssistanceData, showAssistanceComponent } from "../action";
import moment from "moment";
import "moment-timezone";
import { myProfileDataSuccessNeedAssistance } from "../../../../../Epics/MyAccounts/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  getpwUrl,
  initiateTracking,
  recordError
} from "../../../../../utils/commonUtil";
import { PropTypes } from "prop-types";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";
import { needAssistanceDerivedStates } from "../selectors";
import { InputField, InputTextAreaField } from "../../../../../CommonComponents/commonStyles";

export class NeedAssistanceSubmissionComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      basicProfileData: [],
      visibility: ""
    };
  }

  buttonHandle = e => {
    let accountNo = getPrimaryAccount().accountNumber;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      const customerData = {
        fullName: values.userName,
        email: values.email,
        query: values.textArea,
        accountId: accountNo,
        fundName: getPrimaryAccount().accountName,
        date: moment().format("L"),
        time:
          moment(moment.tz(new Date(), "America/New_York")).format("LT") +
          " EST"
      };
      if (!err) {
        const metaData = {
          method: "POST",
          url: `/donor-portal/api/email/${
            getAccountData().partyId
            }/sendCustomerQueryEmail`,
          page: "needAssistance",
          data: customerData
        };
        this.props.submitNeedAssistanceData(metaData);
      }
    });
    initiateTracking("needAssistance", "Need Assistance", "", "Send");
  };

  componentDidMount() {
    this.props.myProfileData({
      metaData: [
        {
          method: "GET",
          url: `/donor-portal/api/profile/${
            getPrimaryAccount().userId
            }/getAccountProfileByAccountIdAndPartyId?partyId=${
            getAccountData().partyId
            }`,
          page: "myProfile"
        }
      ]
    });
  }

  componentWillReceiveProps(np) {
    if (np.profileData) {
      this.setState({
        basicProfileData: np.profileData
      });
    }
    if (np.visible !== this.props.visible) {
      if (this.props.visible) {
        this.setState({
          visibility: np.visible
        });
        this.props.form.resetFields();
      }
    }
  }

  validateUsername = (rule, value, callback) => {
    let blockSpecialRegex = /[0-9~`!@#$%^&()_={}[\]:;,.<>+\/?-]/;
    if (blockSpecialRegex.test(value)) {
      callback("Please enter only Alphabets");
    } else callback();
  };

  render() {
    const { basicProfileData } = this.state;
    const { getFieldDecorator } = this.props.form;
    if (this.props.isLoadingProfile) return <Preloader />;
    return (
      <div>
        <DrawerHeader>Need Assistance?</DrawerHeader>
        <Form onSubmit={this.buttonHandle}>
          <DescriptionPara>
            Is there something we can help you with? If so, we are just an email
            away. Someone will be in touch soon.
          </DescriptionPara>
          <FaqLinkPara>
            For answers to commonly asked questions, please&nbsp;
            <Ahref
              data-test="faq-link"
              href="#"
              onClick={() => {
                try {
                  window.open(getpwUrl() + "/FAQs");
                } catch (error) {
                  recordError(error);
                }
              }}
              className=""
            >
              visit our FAQs.
            </Ahref>
          </FaqLinkPara>
          <HR />
          <FundFromPara>
            Seeking assistance for ‘
            <FundFrom>
              {getPrimaryAccount().accountName
                ? getPrimaryAccount().accountName
                : "-"}
            </FundFrom>
            ’
          </FundFromPara>
          <InputRowWrapper>
            <InputHeader>Full Name:</InputHeader>
            <Form.Item>
              {getFieldDecorator("userName", {
                initialValue: basicProfileData.name,
                rules: [
                  { required: true, message: "Please enter your full name" }
                ]
              })(<InputField  placeholder="Enter full name" width="normal" />)}
            </Form.Item>
            <InputHeader>Email address: </InputHeader>
            <Form.Item>
              {getFieldDecorator("email", {
                initialValue:
                  basicProfileData.email && basicProfileData.email[0].email,
                rules: [
                  {
                    type: "email",
                    message: "Email address should follow the format x@x.x"
                  },
                  { required: true, message: "Please enter your email address" }
                ]
              })(
                <InputField placeholder="Enter email address" width="normal" />
              )}
            </Form.Item>
          </InputRowWrapper>
          <RowWrapper>
            <TextAreaColWrapper spacing="0 17px 0 0">
              <InputHeader>Tell us how we can help:</InputHeader>
              <Form.Item>
                {getFieldDecorator(`textArea`, {
                  rules: [
                    {
                      required: true,
                      message: "Please enter your request"
                    }
                  ]
                })(
                  <InputTextAreaField
                    height="150px"
                    width="500px"
                    placeholder="Enter your question here"
                  />
                )}
              </Form.Item>
            </TextAreaColWrapper>
          </RowWrapper>
          <SubmitButton>
            <GeneralButton
              disabled={false}
              text="SEND"
              type="functional"
              width={"200px"}
              id="btnSend"
              htmlType="submit"
              mobWidth="100%"
            ></GeneralButton>
          </SubmitButton>

        </Form>
      </div>
    );
  }
}
const NeedAssistanceSubmissionForm = Form.create()(
  NeedAssistanceSubmissionComponent
);

NeedAssistanceSubmissionForm.propTypes = {
  isLoadingProfile: PropTypes.bool,
  visible: PropTypes.bool,
  fundName: PropTypes.string,
  profileData: PropTypes.object,
  getFieldDecorator: PropTypes.any
};

const mapStateToProps = state => ({
  profileData: state.getIn([
    "myAccount",
    "profileData",
    "data",
    "profileSummary"
  ]),
  isLoadingProfile: state.getIn(["myAccount", "profileData", "isLoading"]),
  ...needAssistanceDerivedStates(state.toJS())
});

const mapDispatchToProps = dispatch => ({
  submitNeedAssistanceData: data => dispatch(submitNeedAssistanceData(data)),
  showComponent: () => dispatch(showAssistanceComponent()),
  myProfileData: data => dispatch(myProfileDataSuccessNeedAssistance(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NeedAssistanceSubmissionForm)
);
